module.exports = __webpack_public_path__ + "media/format-selector/hybrid_event@2x-e61bb5cf.png";